export const enableRtl = () => document.body.setAttribute('dir', 'rtl');
export const isRtl = () => document.body.getAttribute('dir') === 'rtl';



// WEBPACK FOOTER //
// ./src/lib/document-dir-utils.js